const {
  IS_CAMPER, IS_NNORMAL,
} = require('./system');

const ADYEN_BASE_TRANSLATIONS = ({ holderName }) => ({
  'creditCard.holderName': holderName,
  'creditCard.holderName.placeholder': '',
  'creditCard.numberField.placeholder': '',
  'creditCard.expiryDateField.placeholder': '',
  'creditCard.cvcField.placeholder': '',
  'creditCard.cvcField.placeholder.4digits': '',
  'creditCard.cvcField.placeholder.3digits': '',
});

const ADYEN_STATUS = {
  HANDLE_ACTION: 'HANDLE_ACTION',
  PENDING_3DS2: 'PENDING_3DS2',
  REDIRECT_HPP: 'REDIRECT_HPP',
  PENDING_REDIRECT: 'PENDING_REDIRECT',
};

const CALCULATE_BY_REGION = IS_NNORMAL ? [] : [
  'CA',
  'RU',
];

const CARD_BRANDS = [
  'amex',
  'bcmc',
  'cartebancaire',
  'cup',
  'dankort',
  'diners',
  'discover',
  'electron',
  'jcb',
  'laser',
  'maestro',
  'maestrouk',
  'mc',
  'visa',
  'visadankort',
];

const COUNTRIES_WITH_TAXES = IS_NNORMAL ? [] : [
  'US',
  'RU',
  'CA',
];

const ERROR_MINIMUM_AMOUNT = 'ERROR_MINIMUM_AMOUNT';

const KOREA_EXTRA_POLICIES_URL = {
  1: '/conditions/condiciones_uso_mis_datos_KR00.xhtml',
  2: '/conditions/condiciones_transferir_mis_datos_KR00.xhtml',
  3: '/conditions/condiciones_newsletter_KR00.xhtml',
};

const PAYMENT_CODES = {
  TARJ: 'ADYEN_CARD',
};

const PAYPAL_CODES = [ 'PPLE', 'PPLB', 'PPLY' ];

const RUSSIA_COD_LIST_URL = IS_CAMPER ? 'https://www.camper.com/html/json/suburbs/russia_cod_list.json' : 'https://www.nnormal.com/html/json/suburbs/russia_cod_list.json';

module.exports = {
  ADYEN_BASE_TRANSLATIONS,
  ADYEN_STATUS,
  CALCULATE_BY_REGION,
  CARD_BRANDS,
  COUNTRIES_WITH_TAXES,
  ERROR_MINIMUM_AMOUNT,
  KOREA_EXTRA_POLICIES_URL,
  PAYMENT_CODES,
  PAYPAL_CODES,
  RUSSIA_COD_LIST_URL,
};
